import React, { useEffect, useState, useCallback } from "react";
import { Redirect } from "react-router-dom";
import { withApollo, WithApolloClient } from "react-apollo";
import { deleteAuthObject, authTokensKey } from "../localStorage";

interface IProps {}

const _Logout = (props: WithApolloClient<IProps>) => {
    useEffect(() => {
        deleteAuthObject();
        props.client.resetStore();
        // TODO: remove when issue will be fixed https://github.com/apollographql/apollo-cache-persist/issues/126
        localStorage.removeItem("apollo-cache-persist");
    }, [props.client]);

    return null;
};

export const Logout = withApollo<IProps>(_Logout);

export const CrossTabLogoutHandler = () => {
    const [shouldRedirect, setState] = useState(false);
    const redirect = useCallback(() => setState(true), []);
    useEffect(() => {
        const handler = (event: StorageEvent) => {
            if (
                event.key === authTokensKey &&
                event.oldValue &&
                !event.newValue
            ) {
                redirect();
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, [redirect]);
    return shouldRedirect ? <Redirect to="/logout" /> : null;
};
